import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../common/styles/common.scss";
import { documentsLinks } from "../../constants/constants";
import { getStatusQuo } from "../../services/yourWishes";
import { getUserIdFromLocalStorage } from "../../utils/Utilities";
const SideBar = () => {
  const { t } = useTranslation();
  const [list, setList] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  let uID = getUserIdFromLocalStorage();

  async function fetchData() {
    const result = await getStatusQuo(uID);
    if (result?.payLoad?.length) {
      const listingOfRoutes = documentsLinks.filter(function (array_el) {
        return result.payLoad.filter(function (anotherOne_el) {
          return (
            anotherOne_el.title?.toLowerCase() ==
              array_el.title?.toLowerCase() && anotherOne_el.isWishChecked
          );
        }).length;
      });
      setList(listingOfRoutes);
      if (listingOfRoutes.length) {
        navigate(listingOfRoutes[0].to);
      }
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <Stack className="side-bar" sx={{ width: "100%" }}>
        {list.map((item) => (
          <Link
            key={item.id}
            to={item.to}
            className={`side-link${
              location.pathname === item.route ? " active" : ""
            }`}
          >
            {t(item.name.replace(/\s+/g, "-").toLowerCase())}
          </Link>
        ))}
      </Stack>
    </>
  );
};

export default SideBar;
